import React from "react";

const Login = () => {
  return <div>This is the login page</div>;
};

export default Login;
